import differenceWith from 'lodash/differenceWith';
import { isTruthy } from './isTruthy';

export function removePlansWithIds(plans: { id?: string | null }[], ids: String[]) {
  return differenceWith(plans, ids, (plan: { id?: string | null }, id: String) => plan.id === id);
}

interface HasId {
  id?: string | null;
}

export function getId<T extends HasId>(x: T) {
  return x.id;
}

export function getIds<T extends HasId>(xs: T[]): string[] {
  return xs.map(getId).filter(isTruthy);
}
